import MapView from './MapView.jsx';

export default MapView;
